import PREDEFINED_INTERVALS from '../constants/predefinedIntervals';
import { getUtcOffsetMs } from './timezones';

/**
 * Возвращает { dateStart, dateFinish } для предопределённых интервалов с учётом часового пояса.
 * Поддерживаемые интервалы: TODAY, YESTERDAY, DAY, WEEK, CURRENT_MONTH, LAST_MONTH.
 * @param {string} intervalOption - Ключ предопределённого интервала.
 * @param {string} timeZone - Смещение UTC (например "+03:00").
 * @returns {{dateStart: Date|null, dateFinish: Date|null}} Объект с началом и концом интервала.
 */
const getTimeRangeByInterval = (intervalOption, timeZone) => {
  const offsetMs = getUtcOffsetMs(timeZone);
  const now = Date.now();
  const localMs = now + offsetMs;
  const localDate = new Date(localMs);

  switch (intervalOption) {
    case PREDEFINED_INTERVALS.TODAY: {
      const midnightLocal = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate());
      return { dateStart: new Date(midnightLocal - offsetMs), dateFinish: new Date() };
    }
    case PREDEFINED_INTERVALS.YESTERDAY: {
      const midnightLocal = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate());
      const yesterdayMidnightLocal = midnightLocal - 86400000;
      return { dateStart: new Date(yesterdayMidnightLocal - offsetMs), dateFinish: new Date(midnightLocal - offsetMs) };
    }
    case PREDEFINED_INTERVALS.DAY: {
      const midnightLocal = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate());
      return { dateStart: new Date(midnightLocal - offsetMs - 86400000), dateFinish: new Date() };
    }
    case PREDEFINED_INTERVALS.WEEK: {
      const midnightLocal = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(), localDate.getUTCDate());
      return { dateStart: new Date(midnightLocal - offsetMs - 7 * 86400000), dateFinish: new Date() };
    }
    case PREDEFINED_INTERVALS.CURRENT_MONTH: {
      const monthStart = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(), 1);
      return { dateStart: new Date(monthStart - offsetMs), dateFinish: new Date() };
    }
    case PREDEFINED_INTERVALS.LAST_MONTH: {
      const monthStart = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth(), 1);
      const prevMonthStart = Date.UTC(localDate.getUTCFullYear(), localDate.getUTCMonth() - 1, 1);
      return { dateStart: new Date(prevMonthStart - offsetMs), dateFinish: new Date(monthStart - offsetMs) };
    }
    default:
      return { dateStart: null, dateFinish: null };
  }
};

export default getTimeRangeByInterval;
